import {
    FREE_SUBSCRIPTION_WELCOME_BONUS_ENDPOINT,
    FREE_SUBSCRIPTION_PROMOTIONS_ENDPOINT,
    FREE_SUBSCRIPTION_PROMOTION_BY_ID_ENDPOINT,
    FREE_SUBSCRIPTION_PROMOTION_APPLY_ENDPOINT,
    FREE_SUBSCRIPTION_GRANT_ENDPOINT,
    FREE_SUBSCRIPTION_LOGS_ENDPOINT,
    FREE_SUBSCRIPTION_STATISTICS_ENDPOINT,
    FREE_SUBSCRIPTION_USER_HISTORY_ENDPOINT,
    FREE_SUBSCRIPTION_USER_DEVICES_ENDPOINT,
    FREE_SUBSCRIPTION_DEVICE_USERS_ENDPOINT,
    FREE_SUBSCRIPTION_USER_ELIGIBILITY_ENDPOINT,
    FREE_SUBSCRIPTION_ABUSE_DETECT_ENDPOINT
} from "../api-services/ApiEndpoints";

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

export const getWelcomeBonusSettings = async () => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_WELCOME_BONUS_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch welcome bonus settings: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get welcome bonus settings error:', error);
        throw error;
    }
};

export const updateWelcomeBonusSettings = async (settings) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_WELCOME_BONUS_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(settings)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to update welcome bonus settings: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Update welcome bonus settings error:', error);
        throw error;
    }
};

export const getAllPromotions = async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_PROMOTIONS_ENDPOINT}${queryParams ? `?${queryParams}` : ''}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch promotions: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get promotions error:', error);
        throw error;
    }
};

export const getPromotionById = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_PROMOTION_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch promotion: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get promotion error:', error);
        throw error;
    }
};

export const createPromotion = async (promotionData) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_PROMOTIONS_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(promotionData)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to create promotion: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Create promotion error:', error);
        throw error;
    }
};

export const updatePromotion = async (id, promotionData) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_PROMOTION_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: getAuthHeaders(),
            body: JSON.stringify(promotionData)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to update promotion: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Update promotion error:', error);
        throw error;
    }
};

export const deletePromotion = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_PROMOTION_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to delete promotion: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Delete promotion error:', error);
        throw error;
    }
};

export const applyPromotion = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_PROMOTION_APPLY_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to apply promotion: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Apply promotion error:', error);
        throw error;
    }
};

export const grantFreeSubscription = async (grantData) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_GRANT_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeaders(),
            body: JSON.stringify(grantData)
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to grant free subscription: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Grant free subscription error:', error);
        throw error;
    }
};

export const getFreeSubscriptionLogs = async (params = {}) => {
    const queryParams = new URLSearchParams(params).toString();
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_LOGS_ENDPOINT}${queryParams ? `?${queryParams}` : ''}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch logs: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get logs error:', error);
        throw error;
    }
};

export const getFreeSubscriptionStatistics = async () => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_STATISTICS_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch statistics: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get statistics error:', error);
        throw error;
    }
};

export const getUserFreeSubscriptionHistory = async (userId) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_USER_HISTORY_ENDPOINT.replace('{userId}', userId)}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch user history: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get user history error:', error);
        throw error;
    }
};

export const getUserDevices = async (userId, email = null) => {
    let url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_USER_DEVICES_ENDPOINT.replace('{userId}', userId)}`;
    if (email) {
        url += `?email=${encodeURIComponent(email)}`;
    }
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch user devices: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get user devices error:', error);
        throw error;
    }
};

export const getDeviceUsers = async (deviceId) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_DEVICE_USERS_ENDPOINT.replace('{deviceId}', deviceId)}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch device users: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get device users error:', error);
        throw error;
    }
};

export const checkUserEligibility = async (userId, promotionId, email = null) => {
    let url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_USER_ELIGIBILITY_ENDPOINT.replace('{userId}', userId)}?promotionId=${promotionId}`;
    if (email) {
        url += `&email=${encodeURIComponent(email)}`;
    }
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to check eligibility: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Check eligibility error:', error);
        throw error;
    }
};

export const detectAbuse = async (minAccounts = 2) => {
    const url = `${process.env.REACT_APP_API_URL}${FREE_SUBSCRIPTION_ABUSE_DETECT_ENDPOINT}?minAccounts=${minAccounts}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to detect abuse: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Detect abuse error:', error);
        throw error;
    }
};
